import React, { createContext, PureComponent } from 'react';
import PropTypes from 'prop-types';

const Amp = createContext();
const Provider = Amp.Provider;

export class AmpProvider extends PureComponent {
	state = {
		amp: this.props.amp,
	}

	componentDidMount () {
		this.setState({
			amp: false
		});
	}

	render() {
		return (
			<Provider value={this.state}>
				{this.props.children}
			</Provider>
		);
	}

	static defaultProps = {
		amp: true,
	}

	static propTypes = {
		amp: PropTypes.bool.isRequired,
		children: PropTypes.node.isRequired,
	}
}

export const AmpCheck = Amp.Consumer;
